import { inject } from '@angular/core';
import {
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateFn,
    CanActivateChildFn,
} from '@angular/router';
import { mpiConfig } from '../config/app-config.constants';
import { AuthStore } from '@app/store/auth.store';
import { AuthenticationService } from '@app/core/services/backend/authentication.service';

export const ComplianceGuard: CanActivateFn | CanActivateChildFn = async (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    authStore = inject(AuthStore),
    router: Router = inject(Router),
): Promise<boolean> => {
    if (!authStore.identity()) {
        const hasToken = !!sessionStorage.getItem(AuthenticationService.authTokenStoreKey);
        if (hasToken) {
            await authStore.identityReady();
        }
    }

    if (!authStore.isAuthenticated()) {
        return false;
    }
    const acknowledged = authStore.acknowledgedCompliance();
    if (!acknowledged) {
        router.navigate([mpiConfig.auth.forbiddenRedirect], { queryParams: route.queryParams });
    }
    return acknowledged;
};
